// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","contentWrapper":"G86f96e","iconNoSlotAvailable":"Gd979a9"};